import type { Observable } from 'rxjs';
import type { RegisterUserResult, RegisterUserV2Payload } from '../models/register-user.model';

export abstract class UserRegistrationPort {
  abstract register(payload: RegisterUserV2Payload): Observable<RegisterUserResult>;
}
